<template>
  <div>
    <div class="sidebar-cnt" :class="{ hide: menuHide }">
      <v-icon class="icon-menu" :class="{ hide: menuHide }" @click="hideMenu()">sort</v-icon>
      <div class="side-menu" :class="{ hide: menuHide }">
        <ul id="main-menu">
          <li class="active" id="priorities" @click="anchorNav('mixed','priorities')">{{ $t('general.priorities') }}</li>
          <li id="objectives" @click="anchorNav('mixed','objectives')">{{ $t('general.objectives') }}</li> 
          <li id="strategies" @click="anchorNav('strategies')">{{ $t('views.marketing.strategies') }}</li> 
          <li id="plan" @click="anchorNav('plan')">{{ $t('views.marketing.plan') }}</li>
        </ul>
      </div>
      <div class="print" :class="{ hide: menuHide }" @click="printPage()"><span v-if="!menuHide">{{ $t("general.export_report") }}</span></div>
    </div>

    <div class="content" :class="{ hide: menuHide }">
      <div class="location-info print-only">
          {{ $t('views.diagnostics.location_info') }}<span class="location-data">{{selectedLocation.site}} {{selectedLocation.name}}</span>
      </div>
      <div class="years">
        <div class="year" v-if="currentYear-1!=2018" :class="{'checked': selectedYear==currentYear-1}" @click="changeYear(parseInt(currentYear-1))">{{currentYear-1}}</div>
        <div class="year" :class="[{'checked': selectedYear==currentYear}, {'no-print': selectedYear!=currentYear}]" @click="changeYear(parseInt(currentYear))" >{{currentYear}}</div>
        <div class="year" :class="[{'checked': parseInt(selectedYear)==parseInt(currentYear)+1}, {'no-print': parseInt(selectedYear)!=parseInt(currentYear)+1}]" @click="changeYear(parseInt(currentYear)+1)">{{parseInt(currentYear)+1}}</div>
      </div>
      
      <div>
        <Objectives ref="mixed" :categories="categories" :objectives="marketing"></Objectives>
      </div>
      
      <div ref="strategies" class="jump">
        <div class="subtitle">{{ $t('views.marketing.strategies') }}</div>
        <Strategies :categories="categories" :strategies="marketing"></Strategies>
      </div>

      <div ref="plan" class="plan jump">
        <div class="subtitle">{{ $t('views.marketing.calendar') }}</div>
        <Plan :plan="marketing"></Plan>
      </div>

    </div>
  </div>
</template>

<script>
import i18n from '@/i18n'
import Objectives from '@/components/domain/marketing/Objectives'
import Strategies from '@/components/domain/marketing/Strategies'
import Plan from '@/components/domain/marketing/Plan'

export default {
  name: 'Marketing',
  components: { Objectives, Strategies, Plan },
  data () {
    return {
      currentYear: moment().format('YYYY'),

      selectedYear: parseInt(moment().format('YYYY')),

      strategySelected: undefined,

      menuHide: false,
      scrolling: false,
      scrollWait: false,
    }
  },
  computed: {
    marketing() {
      return Object.values(this.$store.getters['locations/getMarketing']);
    },

    selectedLocation (){
      return this.$store.getters['locations/getSelectedLocation'];
    },

    categories() {
      return this.$store.getters['files/getCategories'](this.type);
    },
  },
  methods: {
   changeYear(year){
    this.selectedYear = year;
   },

   printPage: function() {
      window.print();
    },

    hideMenu: function() {
      this.menuHide = !this.menuHide;
    },

    anchorNav: function(refName, refChild) {
      if (!refChild) {
        var element = this.$refs[refName];
      } else {
        var element = this.$refs[refName].$refs[refChild];
      }
      
      var top = element.offsetTop;
      window.scrollTo(0, top - 80);
      this.handleScroll();
    },

    getScroll () {
      if (!this.menuHide) {
        if (this.scrollWait){
          
          this.scrollWait = true;
        }
        window.clearTimeout(this.scrolling);

        var self = this;

        this.scrolling = setTimeout(function() {
          self.handleScroll();
          self.scrollWait = false;
        }, 500);
      }

    },

    handleScroll () {
      if (document.getElementsByClassName("active").length > 0){
        var active = document.getElementsByClassName("active");
        active[0].className = "";
      }
      var element;
      var exitfor = false;
      for (var index in this.$refs) {
        if ( index=='mixed' ) {
          for (var child in this.$refs.mixed.$refs) {
            if ( (window.scrollY + 90) >= this.$refs[index].$refs[child].offsetTop && window.scrollY + 90 <= (this.$refs[index].$refs[child].offsetTop + this.$refs[index].$refs[child].offsetHeight) ) {
              element = child;
              exitfor = true;
              break;
            }
          }
          if (exitfor) {
            break;
          }
        }
        else if ( (window.scrollY + 90) >= this.$refs[index].offsetTop && window.scrollY + 90 <= (this.$refs[index].offsetTop + this.$refs[index].offsetHeight) ) {
          element = index;
          break;
        }
      }
      document.getElementById(element).className = "active";
    },

    loadData() {
      var self = this;
      this.$overlay.loading();
      this.change = false;
      this.$store.dispatch('locations/loadNationalActions', this.selectedYear );
      this.$store.dispatch('locations/loadMarketing', {restaurant_id: this.$store.getters['locations/getSelectedLocation'].id, year: this.selectedYear} ).then(function(){
        self.$overlay.hide();
      });
    }
  },

  watch: {
    selectedYear() {
      this.loadData();
    },

    selectedLocation() {
      this.loadData();
    },
  },

  created() {
    this.$store.commit('setTitle', i18n.t('views.marketing.name'));
    this.$store.commit('setMenuVisible', false);
    this.loadData();
    this.$store.dispatch('locations/loadCompetence', this.$store.getters['locations/getSelectedLocation'].id );
    this.$store.dispatch('files/loadCategories', {type: undefined});

    window.addEventListener('scroll', this.getScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.getScroll);
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@media print {
  .content {
    margin-top: 10px !important;
  }
}

.location-info {
      font-size: 15px;
      border-bottom: 1px solid #ddd;
      width: 100%;
      padding: 5px 20px;
      margin: 0 auto;
      margin-bottom: 20px;
      text-align: right;
      color: #bbb;

      .location-data {
        font-size: 17px;
        font-weight: bold;
        margin-left: 10px;
      }
    }

/* SIDEBAR */  
  .sidebar-cnt {
    position: fixed;
    left: 30px;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 200px;
    height: 80%;

    i {
      color: var(--secondary_color);
    }

    &.hide {
      width: 50px;
    }

    .icon-menu {
      float: left;
      cursor: pointer;

      &.hide{
        transform: rotate(180deg);
      }
    }

    .side-menu {
      width: 225px;
      display: inline-block;
      float: left;
      padding-bottom: 20px;
      height: 95%;
      margin-top: 20px;

      &.hide {
        visibility: hidden;
      }

      #main-menu {
        text-align: left;
        padding: 0;
        border-right: 2px solid var(--secondary_color);

        li {
          cursor: pointer;
          font-size: 18px;
          margin-top: 20px;
          list-style: none;
          width: fit-content;

          &.active{
            color: var(--secondary_color);
            font-weight: bold;
          }
        }

        ul {
          margin: 0 0 0 2em;

          li {
            font-size: 16px;
            margin-top: 5px;
            list-style: circle;
          }
        }
      }
    }

    .print {
      float: left;
      padding: 10px 20px;
      background-color: var(--secondary_color);
      background: url('/img/export.svg') no-repeat left 5px center;
      background-size: 20px;
      padding-left: 40px;

      color: #555;
      border-radius: 30px;
      font-size: 16px;
      cursor: pointer;

      &.hide {
        background-color: transparent;
        padding: 0px;
        background-image: url('/img/export_sel.svg');
        width: 50px;
        height: 50px;

        i {
          color: var(--secondary_color);
        }
      }
    }
  }


  /*YEARS*/
  .years {
    background-color: #e7e7e7;
    width: fit-content;
    margin-top: 2.5%;
    font-size: 18px;
    position: absolute;
    right: 2.5%;

    .year {
      display: inline-block;
      width: fit-content;
      font-family: Speedee-Bold;
      color: var(--dark_color);
      padding: 0px 10px;
      cursor: pointer;

      &.checked {
        background: var(--main_color);
      }
    }
  }


  /* CONTENT */

  .content {
    width: calc( 100% - 200px );
    display: inline-block;
    float: right;
    padding: 20px 40px;

    .cover {
      width: 70%;
      display: block;
      margin: 0 auto;
      margin-top: 40px;
    }

    &.hide {
      width: calc( 100% );
      transition: 0.2s;
    }
  }

  .subtitle {
    background: var(--main_color);
    color: var(--dark_color);
    display: inline-block;
    text-align: center;
    font-size: 25px;
    font-family: Speedee-Bold;
    margin: 0;
    margin-top: 100px;
    padding: 0px 10px;
    z-index: 1;
  }

  .plan {
    min-height: 100vh;
  }

</style>

<style lang="scss">

@media print {

    #header, .separador, #footer{
      display: none !important;
    }

    table{
      max-height: 100% !important;
    }

    #app{

      background-color: white !important;
    }

    .sidebar-cnt {
      display: none !important;
    }

    .content {
      width: 100% !important;
      padding: 0px !important;
      margin: 0px 0px !important;
      float: none;
    }

    .objectives {

      .subtitle {
        margin-top: 0px !important;
      }

    }

    .subtitle {
        margin-top: 30px !important;
      }

    .years {
      margin-top: 0 !important;
    }

    .strategies-table {
      margin-top: 0px !important;
    }

    .no-print, .no-print * {
      display: none !important;
    }

    .jump {
      page-break-inside: avoid !important;
      page-break-before: always !important;
    }

    .objectives-table {
      width: 100% !important;
      margin: 0 auto !important;

      td {
        padding: 15px 10px !important;
      }
    }

    .plan {
      min-height: initial !important;
    }

    .actions {
      width: 100% !important;

      .action, .list {
        width: 100% !important;
      }
    }

  }

</style>
